import React from "react";
import { Button } from "@tennr/frontend/components/Button";
import { Heading } from "@tennr/frontend/components/Heading";
import "./CaseStudiesHeroSection.css";

export const CaseStudiesHeroSection: React.FC = () => {
  const handleClick = () => {
    const el = document.getElementById("case-studies");
    if (!el) return;
    const { top } = el.getBoundingClientRect();
    const pageOffset = window.pageYOffset || document.documentElement.scrollTop;
    scrollTo({ top: top + pageOffset, behavior: "smooth" });
  };

  return (
    <section className="case-studies-hero-section">
      <Heading
        title="CUSTOMER STORIES"
        heading="Results you can measure"
        body="Healthcare operators drive better outcomes with Tennr."
        variant="xl"
        position="left"
      />
      <Button minWidth="232px" width="232px" minHeight="58px" text="READ CASE STUDIES" onClick={handleClick} />
    </section>
  );
};
